export const supportedProjects = ["AWS CV Data collection", "Face program", "Covid vaccination records"]

type ProjectToFeatureMap = {
    [key: string]: string
}
export const projectToFeatureMap: ProjectToFeatureMap = {
    "AWS CV Data collection": "Handshake",
    "Face program": "Face",
    "Covid vaccination records": "CovidVaccination"
}